import axios from 'axios'
import qs from 'qs'
import { lib } from '../assets/js/lib'
import store from './../vuex/store'
import router from "@/router";
const instance = axios.create({
  baseURL: 'https://api.zhixuejun.com',
  //baseURL: 'https://testapi.zhixuejun.com',
  withCredentials: true, // 是否携带cookie
  timeout: 10000,
  headers: {
    //'Content-Type': 'application/x-www-form-urlencoded',
    //Authorization: "NTE4Mzg6MTIzNDU2",
  }
})

axios.defaults.retry = 1  // 重试次数，
axios.defaults._retryCount = 0  // 默认不重试,同时用此属性标记该请求是否为一个重试请求
axios.defaults.timeout = 5000 // 默认超时时
//instance.defaults.headers.post["Content-Type"] = "application/x-www-form-urlencoded";
// instance.defaults.headers.post["Content-Type"] = "application/json";
// instance.defaults.headers.get['Content-Type'] = 'application/json';
// // 添加请求拦截器
function initAxios() {
  // 添加请求拦截器
  instance.interceptors.request.use(
    config => {
      if(config.method==='post' && (config.headers['Content-Type'] === 'application/x-www-form-urlencoded'))
      {
        config.data = qs.stringify(config.data) // 转为formdata数据格式
      }
      if (store.state.token) {
        config.headers.Authorization = store.state.token;
      }
      return config
    },
    error => Promise.error(error)
    // function (config) {

    //         config.headers.Authorization = 'NTE4Mzg6MTIzNDU2'

    //   return config;
    // async config => {
    //   config.originUrl = config.url
    //   config.routeConvert = false
    //   window._axiosRequestConfigAll = config
    // if(!config.__retryCount){
    //   await routeConvert(config.url).then(routeData => {
    //     config.url = routeData.isResend ? routeData.url : routeData.originUrl
    //     config.isResend = routeData.isResend
    //     config.routeConvert = true
    //     config.timeout = routeData.timeout || axios.defaults.timeout
    //   })
    //     .catch(
    //       err => {
    //         window.Omega && window.Omega.trackEvent && window.Omega.trackEvent('tech_ibt_router_retry', '合规路由请求失败', {
    //           sourceURL: config.url,
    //           isAxiosError: true,
    //           message: JSON.stringify(err),
    //           request: JSON.stringify(config.params)
    //         })
    //         return Promise.reject({
    //           status: 6001,
    //           statusText: 'router sdk error:' + JSON.stringify(err)
    //         })
    //       }
    //     )
    // }
    // return config;
    // },
    // err => {
    //   return Promise.reject(err);
    // }
  )


  instance.interceptors.response.use(
    response => {
      return response
    },
    error => {
      if (error.response) {
        switch (error.response.status) {
          case 401:
            // 这里写清除token的代码
            store.dispatch("cleanUser");
            router.replace({
              path: '/login',
              query: {redirect: router.currentRoute.fullPath}//登录成功后跳入浏览的当前页面
            })
        }
      }
    //   let config = _axiosRequestConfigAll
    // if(config.routeConvert && config.isResend || err.status === 6001){ // 如果合规路由下发接口请求失败或者合规路由sdk错误，原始url重试
    //   let config = err.config;
    //   config.__retryCount = config.__retryCount || 0;
    //   if (config.__retryCount >= config.retry) { // 检查重试次数是否超过允许重拾次数
    //     return Promise.reject(err);
    //   }
    //   config.__retryCount += 1;
    //   config.url = config.originUrl
    //   return axios(config)
    // } else {
    //   window.Omega && window.Omega.trackEvent && window.Omega.trackEvent('tech_ibt_ajax_fail', '数据请求错误', {
    //     sourceURL: config.url,
    //     message: JSON.stringify(err),
    //     request: JSON.stringify(config.params)
    //   })
       return Promise.reject(error)
    // }
    }
  )
}

initAxios()

function retry(resolve, reject, method, retryAttempt = 1) {
  method().then(
    res => {
      // 请求成功
      resolve(res);
    }
  ).catch(err => {
    // 请求失败，重试2次
    // if (retryAttempt < 3) {
    //   setTimeout(() => {
    //     retry(resolve, reject, method, ++retryAttempt);
    //   }, 1500);
    // } else {
    //   reject(err);
    // }
  });
}

function get(url, options = {}) {
 return new Promise((resolve, reject) => {
    retry(resolve, reject, () => {
      return instance.get(url, options);
    })
  })
}

function post(url, body = {}, options = {}) {
  return new Promise((resolve, reject) => {
    retry(resolve, reject, () => {
      return instance.post(url, body, options);
    })
  })
}

export default {
  get,
  post,

};





// WEBPACK FOOTER //
// ./src/api/index.js